const welcome = {
    title: 'Bem-vindo a consola de Administrador',
    description: 'A consola de Administrador é o lugar para gerenciar o Logto sem ter conhecimentos de programação. Vamos primeiro criar uma conta. Com esta conta, pode gerir o Logto por conta própria ou em nome da empresa.',
    create_account: 'Criar uma conta',
};
export default Object.freeze(welcome);
